<template lang="html">

    <div class="cover-popup row-center" v-if="showaviso">

        <span class="close-cover" @click="close"></span>

        <div class="popup">

            <a @click="close" class="close">✕</a>

            <h3 class="title-pop">Para poder aplicar a ofertas de prácticas es
                obligatorio subir el CV.</h3>

            <dropzone @emit="setDoc" ref="dropzone"></dropzone>

            <div class="contenedor-botones row-center">
                <button class="btn" @click="send" :loading="loading">Adjuntar</button>
            </div>
        </div>
    </div>


</template>

<script lang="js">

    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);


    import dropzone from '@/components/parts/dropzone';

    import {mapGetters, mapActions} from 'vuex';


    export default {
        name: 'popup-cv',
        methods:{
            ...mapActions(['addDoc','removeAvisoCV']),
            close(){
                this.removeAvisoCV();
            },
            send() {
                this.clicked = true;
                this.$validator.validateAll()
                .then(itsOk => {
                    if (itsOk) {
                        this.loading = true;
                        this.addDoc(this.data).then(r => {
                        if(r){
                            this.close();
                        }
                        }).finally(e => {  
                            this.loading = false;
                        });
                    }
                });
            },
            setDoc(value) {
                for(let i in value){
                    this.data[i] = value[i];
                }
            },
        },
        computed : {
            ...mapGetters({
                showaviso : 'getAvisoCV'
            })
        },
        data() {
            return {
                loading : false,
                data : {
                    "id": "",
                    "fecha": "",
                    "tipo": "1",
                    "enlace": "",
                    "nombre": "",
                    "ficheroB64ParaAltas": "",
                    "extension_adjunto": "",
                    "idDocumentoNecesarioOfertaNoTipado": 0
                }
            }
        },
        components : {
            'dropzone': dropzone,
        }
    }
</script>

<style scoped lang="scss">
.cover-popup .popup .btn {
  margin-top: 0;
}

.contenedor-check{
    margin-top: 20px;
}

</style>


// WEBPACK FOOTER //
// src/components/parts/popup-adjuntar-cv.vue